/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useEffect, useState } from 'react';
import FooterButton from 'src/components/FooterBtn/FooterButton';
import HeaderPage from 'src/components/header/HeaderPage';
import NavbarHeader from 'src/components/header/NavbarHeader';
import useQueryString from 'src/hooks/useQueryString';
import { guardarLead } from 'src/services';
import InfoPtp from '../../components/InfoPtp';
import withCotizacion from '../../HOC/withCotizacion';

const ESTADOS_COTIZACION = {
  ACTIVA: 'N',
  PAGADA: 'PM',
  PAGADA_FINAL: 'P',
  PAGO_RECHAZADO: 'PRM',
  PAGO_PENDIENTE: 'PNM',
};

const PtpMontoMinimoFromCorreo = ({
  idCotizacion,
  cotizacion,
  history,
  addSuccessToast,
  addWarningToast,
}) => {
  const { cotEstado } = cotizacion;
  const { idSuscripcion } = useQueryString();
  const [estadoPago, setEstadoPago] = useState('');

  useEffect(() => {
    guardarLead(idCotizacion, `P2P_MONTO_MINIMO_FROM_CORREO__INGRESO`);
    guardarLead(
      idCotizacion,
      `VERIFICAR_TOKEN_PAGO__ESTADO_COTIZACION__${cotEstado}`,
    );
    switch (cotEstado) {
      case ESTADOS_COTIZACION.ACTIVA:
      case ESTADOS_COTIZACION.PAGADA:
      case ESTADOS_COTIZACION.PAGADA_FINAL:
        addSuccessToast('SU SUSCRIPCION SE HA REALIZADO EXITOSAMENTE', {
          autoDismiss: false,
        });
        if (['6','7'].includes(cotizacion.flujoPlugin)) {
          // history.push(`/ingresarPoliza/${idCotizacion}`);
          if (`${cotizacion.producto.tieneFirma}` === '1') {
            switch (cotizacion.medioFirma) {
              case 'evicertia':
                return history.push(`/firmarCertificado/${idCotizacion}`);
      
              case 'token':
                // return history.push(`/verificarTokenPago/${idCotizacion}/${idPoliza}`);
                return history.push(`/verificarTokenPago/${idCotizacion}/${idCotizacion}`);
              default:
                // addErrorToast('Cotizacion no tiene el medio para la firma', { autoDismiss: false });
                break;
            }
          } else {
            return history.push(`/ingresarPoliza/${idCotizacion}/`);
          }
        } else {
          history.push(`/primer-pago-suscripcion/${idCotizacion}/${idSuscripcion}`);
        }
        break;

      case ESTADOS_COTIZACION.PAGO_RECHAZADO:
        //history.push(`/newPaginaCompra/${idCotizacion}`);
        setEstadoPago('RECHAZADO');
        addWarningToast('SU PETICION DE PAGO HA SIDO RECHAZADA.', {
          autoDismiss: false,
        });
        break;

      default:
        break;
    }
  }, []);

  

  const onClickNuevamente = () => {
    guardarLead(
      idCotizacion,
      `P2P_MONTO_MINIMO_FROM_CORREO__INTENTAR_NUEVAMENTE`,
    );
    history.push(`/newPaginaCompra/${cotizacion.idCotizacion}`);
  };

  return (
    <div className="container-fluid text-center ">
      <NavbarHeader />
      <HeaderPage progreso={70} />
      <InfoPtp
        valor="1"
        resultado={estadoPago}
        referencia={idCotizacion}
        pago={estadoPago}
        label="Cobro prueba"
        periocidadPago="El cobro realizado sera reversado de forma automatica"
      >
        <React.Fragment>
          {estadoPago === 'RECHAZADO' && (
            <div className="col-12 mt-5">
              <h6>
                Su petición de pago ha sido <strong>rechazado</strong>
              </h6>
              <FooterButton
                label="Intentar nuevamente"
                onClick={onClickNuevamente}
              />
            </div>
          )}
        </React.Fragment>
      </InfoPtp>
    </div>
  );
};

      export default withCotizacion(PtpMontoMinimoFromCorreo);
